import request from '../utils/request';

export function getSuiteList(params) {
    return request({
        url: '/suite/get_list',
        method: 'get',
        params
    });
}
